export default "__VITE_ASSET__6a713723__"